<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h360_dialog abow_dialog"
      width="300px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              导出分析报告
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item
                    label="省区"
                    prop="provinceId"
                  >
                    <el-select
                      v-model="dialogAddEditViewForm.provinceId"
                      filterable
                      clearable
                      placeholder="请选择省区"
                      style="width:100%"
                      @change="changeProvinceFun"
                    >
                      <el-option
                        v-for="item in provinceOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="报告周期"
                    prop="settingId"
                  >
                    <el-select
                      v-model="dialogAddEditViewForm.settingId"
                      filterable
                      clearable
                      placeholder="请选择报告周期"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in settingIdOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="handleSave"
        >
          导出报告
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { loadAreaDataApi } from '@/api/area'
import { loadRetailSurveyInfoExportReportDataApi, loadRetailSurveyExportCycleSettingSelectDataApi } from '@/api/retailSurveyInfo'
export default {
  components: { },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        provinceId: [ { required: true, message: '请选择省区', trigger: 'change' }],
        settingId: [ { required: true, message: '请选择报告周期', trigger: 'change' }]
      },
      provinceOptions: [],
      settingIdOptions: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.provinceOptions = []
        this.settingIdOptions = []
        this.dialogAddEditViewForm = {
          provinceId: null,
          settingId: ''
        }
        this.initProvinceSelectData()
      }
    }
  },
  methods: {
    // 获取省区下拉框数据
    initProvinceSelectData() {
      loadAreaDataApi({ parentId: 1, isUserArea : 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
        this.loading = false
      })
    },
    // 省区选择回调
    changeProvinceFun(val) {
      this.settingIdOptions = []
      this.dialogAddEditViewForm.settingId = ''
      if(val === null || val === ''){
        return false
      }
      this.initSettingSelectData(val)
    },
    // 初始期数下拉数据
    initSettingSelectData(val){
      loadRetailSurveyExportCycleSettingSelectDataApi({ provinceId: val, orderCondition: 'order by id desc limit 20' }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.settingIdOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            '是否确定导出分析报告','系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText:'取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.saveOrUpdate()
            })
            .catch(() => { })
        }
      })
    },
    // 保存新增
    saveOrUpdate () {
      loadRetailSurveyInfoExportReportDataApi(this.dialogAddEditViewForm).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
      this.$message({
        dangerouslyUseHTMLString: true,
        type: 'success',
        message: `<strong>${this.$t('operation.tips_export')}</strong>`,
        duration: 5000,
        offset: 80
      })
    }
  }
}
</script>
<style lang="scss"  scoped>

</style>
